import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function TasksAPI(): BringozApi {
  return {
    base: `/tasks`,
    infiniteScroll: {
      address: `/tasks`,
      cmd: 'GET'
    },
    actions: {
      complete: {
        address: 'actions/complete',
        cmd: 'POST',
        updateable: true
      },
      updateInternalTask: {
        address: '{id}/internalTask',
        cmd: 'POST',
        updateable: false,
      },
      cancelTask: {
        address: 'actions/cancel',
        cmd: 'POST',
        updateable: true
      },
      getOfflineActions: {
        address: 'sync/actions',
        cmd: 'GET',
        updateable: false
      },
      changeStatus_CourierHeading: {
        address: 'update/CourierHeading',
        cmd: 'POST',
        updateable: true
      },
      changeStatus_CourierArrived: {
        address: 'update/CourierArrived',
        cmd: 'POST',
        updateable: true
      },
      changeStatus_CourierDeparted: {
        address: 'update/CourierDeparted',
        cmd: 'POST',
        updateable: true
      },
      changeStatus_Assigned: {
        address: 'update/Assigned',
        cmd: 'POST',
        updateable: true
      },
      editTaskServiceTime: {
        address: '{taskId}/servicetime',
        cmd: 'POST',
        updateable: true
      },
      editTaskExtraInfo: {
        address: '{taskId}/edit/extraInfo',
        cmd: 'POST',
        updateable: true
      },
      revertTaskStatus: {
        address: '{taskId}/revert',
        cmd: 'POST',
        updateable: false
      }
    }
  }

}

angular
  .module('bringoz.admin.tasks')
  .factory('tasksAPI', TasksAPI);
